<template>
  <div class="page-content pdf-film-fee-balance">
    <h1 class="page-title">{{ $locale("sideMenu.reports.boxSaleReport") }}</h1>
    <!-- Search Area -->
    <el-form
      ref="form"
      class="search-area"
      :model="formData"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="10">
          <el-form-item
            prop="monthDate"
            required
            :label="''"
            :show-message="false"
          >
            <DatePickerGroup
              v-bind:start="formData.startTime"
              v-bind:end="formData.endTime"
              @setFatherDate="getDate"
            ></DatePickerGroup>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            prop="cinemaIds"
            required
            :label="$locale('global.titleOfWork')"
            :show-message="false"
          >
            <el-select v-model="formData.filmId" filterable>
              <el-option
                v-for="item in filmList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-button class="download egl-btn-yellow" @click="downloadPdf" :disabled="btnDisabled">{{$locale('global.download')}}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div class="table-module info-supplement-container"></div>
  </div>
  <!-- </div> -->
</template>

<script>
import DatePickerGroup from "@/components/DatePickerGroup";
import { getExportDailyMovieRevenueReport } from "@/helpers/service/api/report";
// import { getMovieList } from "@/helpers/service/api/common.js";
import { getFilmList } from "@/helpers/service/api/report";

export default {
  name: "BoxOfficeSales",
  data() {
    return {
      onSearch: {
        startDate: 0,
        endDate: 0,
        filmId: "",
      },
      searchTime: "",
      cinemaId: window.localStorage.getItem("cinemaId"),
      filmList: [],
      formData: {
        startTime: this.$moment().startOf("day").valueOf(),
        endTime: this.$moment().endOf("day").valueOf(),
        filmId: ""
      }
    };
  },
  computed: {
    btnDisabled() {
      let result = false;
      result = Object.values(this.formData).findIndex(_val => !_val) > -1;
      return result;
    }
  },
  methods: {
    getDate(obj) {
      this.formData = {
        startTime: obj.startDate,
        endTime: obj.endDate,
      };
    },
    downloadPdf() {
      if (this.formData.filmId) {
        const params = {
          startDate: this.formatDate(this.formData.startTime),
          endDate: this.formatDate(this.formData.endTime),
          filmId: this.formData.filmId || "",
          cinemaId: this.cinemaId,
        };

        getExportDailyMovieRevenueReport(params).then(res => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
          const content = new TextEncoder().encode(res);
          const blob = new Blob([ bom, content ], { type: 'text/csv;charset=utf-8;' });
          const blobUrl = window.URL.createObjectURL(blob);
          const aElement = document.createElement("a");
          aElement.href = blobUrl;
          aElement.download = `${this.$locale("sideMenu.reports.boxSaleReport")}.csv`;
          aElement.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      } else {
        this.$alert(this.$locale("trans.box.plsSelectFilm"));
      }
      
    },
    getFilmList() {
      // getMovieList({
      //   cinemaId: this.cinemaId,
      //   approve: true,
      // }).then(res => {
      //   this.filmList = res.data.data;
      // });
      getFilmList({
        cinemaId: this.cinemaId,
        startDate: this.$moment(this.formData.startTime).format("YYYY-MM-DD"),
        dailyReport:true
      }).then(res => {
        this.filmList = res.data;
      })
    },
    search_fn() {},
    formatDate(timestamp) {
      return this.$moment(timestamp).format("YYYY-MM-DD");
    },
  },
  mounted() {
    const today = this.$moment().valueOf();

    this.onSearch = {
      startDate: today,
      endDate: today,
    };
    this.getFilmList();
    this.search_fn();
  },
  components: {
    DatePickerGroup,
  },
};
</script>
<style scoped lang="less">
.pdf-film-fee-balance {
  position: relative;
  overflow: hidden;

  .el-col {
    margin-bottom: 5px;
  }
  .makeInline {
    white-space: nowrap;
  }
  .pdf-viewer {
    position: absolute;
    z-index: -1;
  }
  .search-area {
    .datepicker {
      display: flex;

      .el-input {
        padding: 0 10px;
      }
    }
    .download {
      margin-top: 40px;
    }
  }
}
</style>